import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

export type WeekDays = {
  0: 'Segunda-feira',
  1: 'Terça-feira',
  2: 'Quarta-feira',
  3: 'Quinta-feira',
  4: 'Sexta-feira',
  5: 'Sábado',
  6: 'Domingo',
}

interface Error {
  response: {
    status: number
  }
}

interface ResponseAvailability {
  start_date: string
  end_date: string 
}

interface ResponseAvailabilities {
  [weekDay: string]: ResponseAvailability[]
}

interface Response {
  data: {
    availabilities: ResponseAvailabilities
  }
}

export interface Availability {
  startDate: Date
  endDate: Date 
}

export type Availabilities = {
  [weekDay in keyof WeekDays]: Availability[] 
}

interface AvailabilitiesData {
  availabilities: Availabilities
}

interface AvailabilitiesProps {
  patientUsername: string
  professionalUsername: string
}

export const availabilities = ({
  patientUsername,
  professionalUsername,
}: AvailabilitiesProps): Promise<AvailabilitiesData> => {

  //eslint-disable-next-line
  const endpoint = apiEndpoints.RESERVATIONS_AVAILABILITIES(professionalUsername, patientUsername)
  
  return new Promise<AvailabilitiesData> ((resolve, reject) => {
    axios.get(endpoint)
      .then((response: Response) => {
        const availabilities = {} as Availabilities

        Object.entries(response.data.availabilities).forEach(([weekDay, responseAvailabilities]) => {
          const formattedAvailability = responseAvailabilities.map((av) => {
            return {
              startDate: new Date(av.start_date),
              endDate: new Date(av.end_date),
            } as Availability
          })

          availabilities[weekDay] = formattedAvailability
        })
        
        resolve({ availabilities })
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}